// Mirrors: App\Enums\RewardType (core)
export const RewardType = Object.freeze({
    NULL: 1,
    COINS: 2,
    TICKETS: 3,
    ATTRIBUTE_POINTS: 4,
    ABILITY_POINTS: 5,
    CHARACTER_POINTS: 6,
});
